import { render } from "./details.vue?vue&type=template&id=30ec58bc&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

import "./details.vue?vue&type=style&index=0&id=30ec58bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ec58bc"]])

export default __exports__